import React from 'react';
import { Box, Typography, Container, Button } from '@mui/material';
import { config } from '../../config/config'; // Adjust the import path if necessary
import { Link } from 'react-router-dom';

const ErrorPage = ({ title, message, buttonLink = '', buttonText }) => {
    return (
        <Container
            maxWidth="md"
            sx={{
                marginTop: '100px',
                marginBottom: '36px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
            }}
        >
            <Box
                component="img"
                src={`${config.imageUrl}not-found.png`}
                alt="Not Found"
                sx={{
                    width: '250px',
                }}
            />
            <Typography variant="h6" align="center">
                {title || 'No Data Found'}
            </Typography>
            <Typography
                variant="body1"
                align="center"
                sx={{ mb: 2, color: 'text.secondary' }}
            >
                {message}
            </Typography>
            {buttonLink && (
                <Link to={buttonLink}>
                    <Button>{buttonText}</Button>
                </Link>
            )}
        </Container>
    );
};

export default ErrorPage;
